/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import CSSModules from 'react-css-modules';
import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import gatewayActions from 'loraactions/gateway';
import IntlMsg from 'lorautils/intl/IntlMsg';
import SideBar from 'loracoms/SideBar';
import SidebarContainer from 'loracoms/SidebarContainer';
import styles from './styles.scss';


const defaultProps = {
  view: '',
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  getGateway: React.PropTypes.func.isRequired,
  gateway: React.PropTypes.object.isRequired,
  resetGetGateway: React.PropTypes.func.isRequired,
  children: React.PropTypes.node.isRequired,
  view: React.PropTypes.string,
};

class GatewayDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gateway: props.gateway,
      view: props.view,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail');
  }

  componentWillMount() {
    const { gatewayId, getGateway } = this.props;
    getGateway(gatewayId);
  }

  componentWillReceiveProps(nextProps) {
    const { gateway, view } = nextProps;
    if (gateway !== this.props.gateway) {
      this.setState({ gateway });
    }
    if (view !== this.props.view) {
      this.setState({ view });
    }
  }

  componentWillUnmount() {
    const { resetGetGateway } = this.props;
    resetGetGateway();
  }

  renderSideBar() {
    const { pushState, gatewayId } = this.props;
    const { view } = this.state;
    return (
      <SideBar
        height={window.innerHeight}
        title={this.intlMsg.msg('sidebar.title')}
        menuItems={[{
          icon: <span className="glyphicons glyphicons-blackboard" />,
          text: this.intlMsg.msg('menu.detail'),
          onClick: () => pushState(`/gateway/detail/${gatewayId}`),
          active: view === '',
        },
        {
          icon: <span className="glyphicons glyphicons-pie-chart" />,
          text: this.intlMsg.msg('menu.stat'),
          onClick: () => pushState(`/gateway/detail/${gatewayId}/stat`),
          active: view === 'stat',
        },
        {
          icon: <span className="glyphicons glyphicons-transfer rotate270" />,
          text: this.intlMsg.msg('menu.datamsg'),
          onClick: () => pushState(`/gateway/detail/${gatewayId}/datamsg`),
          active: view === 'datamsg',
        },
        {
          icon: <span className="glyphicons glyphicons-wrench" />,
          text: this.intlMsg.msg('menu.conf'),
          onClick: () => pushState(`/gateway/detail/${gatewayId}/conf`),
          active: view === 'conf',
        },
        {
          icon: <span className="glyphicons glyphicons-notes-2" />,
          text: this.intlMsg.msg('menu.log'),
          onClick: () => pushState(`/gateway/detail/${gatewayId}/log`),
          active: view === 'log',
        }]}
      />
    );
  }

  renderError() {
    const { gateway } = this.state;
    const { error: { code } } = gateway;

    return (
      <div className={styles.error}>
        <h5><span className="glyphicons glyphicons-alert" /></h5>
        <h5>
          { this.intlMsg.errorMsg(code) }
        </h5>
        <Button
          bsStyle="link"
          onClick={() => this.props.pushState('/gateway')}
        >
          { this.intlMsg.msg('error.goback') }
        </Button>
      </div>
    );
  }

  render() {
    const { gateway } = this.state;
    const { status } = gateway;

    if (status === 'failure') {
      return this.renderError();
    }

    return (
      <div className={styles['wrapper-nopadding']}>
        {this.renderSideBar()}
        <SidebarContainer>
          <div className={styles.view}>
            {this.props.children}
          </div>
        </SidebarContainer>
      </div>
    );
  }
}

GatewayDetail.defaultProps = defaultProps;
GatewayDetail.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  gatewayId: ownProps.params.id,
  gateway: state.gateway.gateway,
  view: ownProps.location.pathname.split('/')[4] || '',
});

const mapDispatchToProps = ({
  pushState: routerActions.push,
  getGateway: gatewayActions.gateway,
  resetGetGateway: gatewayActions.resetGetGateway,
});


export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(GatewayDetail, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/index.jsx